module.exports = __webpack_public_path__ + "img/icon_whatsap.e4c140f8.svg";